module.exports = __webpack_public_path__ + "static/media/feedback-left.2a3aef69.png";